import { FieldState } from '@/corePagesModule/composables/useForm';
import { MasterPairResolverService } from '@/corePagesModule/service/masterPairResolverService';
import { Ref } from 'vue';

/**
 * useFormのFieldStateを更新するomposable
 * @param fieldState - useFormのフィールドステート
 * @param isEdited - 編集済みかどうかの
 */
export const useUpdateFieldState = (fieldState: FieldState, isEdited?: Ref<boolean>) => {
  /**
   * フォームの値を変更した際の処理
   * @param option - フォームの種類
   * @param value - 値
   */
  const updateValue = async (option: string, value: string) => {
    if (isEdited) isEdited.value = true;

    fieldState[option].setValue(value);

    const resolved = await MasterPairResolverService.resolveMasterPairValue(option, value);

    if (resolved && fieldState[option].value.value === value) {
      fieldState[resolved.targetKey].setValue(resolved.value);
    }
  };

  /**
   * 担当者フォームの値を変更した際の処理
   * @param option - フォームの種類
   * @param value - 値
   */
  const updateUserValue = (option: string, value: string[]) => {
    if (isEdited) isEdited.value = true;
    fieldState[option].setValue(value.join(','));
  };

  /**
   * 新規選択肢追加ボタンを押した際の処理
   * @param type - 選択肢の種類
   * @param name - 名前
   * @param code - コード(Package, Manufacturer, EndUserはなし)
   */
  const addNewOption = (type: string, name: string, code?: string) => {
    switch (type) {
      case 'package':
      case 'manufacturer':
      case 'endUser':
        fieldState[type].setValue(name);
        break;
      default:
        if (!code) {
          console.error('エラー:取引編集>新規選択肢追加:Codeなし');
          return;
        }
        fieldState[type + 'Name'].setValue(name);
        fieldState[type + 'Number'].setValue(code);
    }
    if (isEdited) isEdited.value = true;
    return;
  };

  return {
    addNewOption,
    updateValue,
    updateUserValue,
  };
};
